export default __webpack_public_path__ + "static/media/caret-down.efc6957c.svg";